import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState } from '@y42/angular/util';
import { AppQuery } from '@y42/app-state';
import { GitQuery } from '@y42/git';
import { combineLatest, filter, map, startWith } from 'rxjs';
import { animationAppearDisappear } from '../../../core/animations/appear-disappear';

@UntilDestroy()
@Component({
  selector: 'y42-status-indicator',
  templateUrl: './status-indicator.component.html',
  styleUrls: ['./status-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [animationAppearDisappear(50, 150)],
})
export class StatusIndicatorComponent {
  constructor(private readonly appQuery: AppQuery, private readonly gitQuery: GitQuery) {}

  @Input() transparentBackground = false;

  private readonly error$ = this.gitQuery.gitStatus$.pipe(map((status) => !!status?.error));

  readonly state = connectState(this, {
    show: combineLatest([
      this.appQuery.loading$,
      this.gitQuery.loading$,
      this.gitQuery.isOperationOngoing(),
      this.error$.pipe(filter(Boolean), startWith(false)),
    ]).pipe(map(([appLoading, gitLoading, ongoing, error]) => appLoading || gitLoading || ongoing || error)),
    error: this.error$,
    statusDescription: combineLatest([this.appQuery.statusDescription$, this.gitQuery.gitStatusDescription$]).pipe(
      map(([appStatus, gitStatus]) => appStatus || gitStatus || ''),
    ),
  });
}
